import { useDispatch, useSelector } from "react-redux";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import { emailSettingsSelector } from "./selector";
import { useEffect, useState } from "react";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import Spinner from "../common/Spinner/spinner";
import {
  getEmailApproachDropdownList,
  getEmailPageDetails,
  saveEmailSetup,
} from "./action";
import { updateFileld } from "./slice";
import Error from "../common/Message/error";
import Success from "../common/Message/success";

export default () => {
  // useDispatch Hook
  const dispatch = useDispatch();
  // useConfigration Hook
  const config = useConfiguration();
  // useSession Storage
  const storage = useSessionStorage();
  // get a login details
  const login = storage.getItem("login");
  // get details form email selector
  const {
    loadingFlag,
    emailApproachList,
    emailFormData,
    successMessage,
    errorMessage,
  } = useSelector(emailSettingsSelector);

  // Error form data
  const [errors, setErrors] = useState({});

  // handleChange for Input data
  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateFileld({ field: name, value }));
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  // Validation Part
  const validation = () => {
    // Error Initialized
    let tempErrors = {};
    let formIsValid = true;
    // email Approach Validate
    if (!emailFormData.emailApproach) {
      formIsValid = false;
      tempErrors.emailApproach = "This field is Required";
    }
    // email server Validate
    if (emailFormData.emailApproach === "3") {
      if (!emailFormData.emailServer) {
        formIsValid = false;
        tempErrors.emailServer = "This field is Required";
      } else if (!/\S+@\S+\.\S+/.test(emailFormData.emailServer)) {
        formIsValid = false;
        tempErrors.emailServer = "Email is Invalid";
      }
      // common email Validate
      if (!emailFormData.commonEmail) {
        formIsValid = false;
        tempErrors.commonEmail = "This field is Required";
      } else if (!/\S+@\S+\.\S+/.test(emailFormData.commonEmail)) {
        formIsValid = false;
        tempErrors.commonEmail = "Email is Invalid";
      }
      // password Validate
      if (!emailFormData.password) {
        formIsValid = false;
        tempErrors.password = "This field is Required";
      }
      // display name Validate
      if (!emailFormData.displayName) {
        formIsValid = false;
        tempErrors.displayName = "This field is Required";
      }
    } else if (emailFormData.emailApproach === "2") {
      // dns text Validate
      if (!emailFormData.dnsText) {
        formIsValid = false;
        tempErrors.dnsText = "This field is Required";
      }
    }

    setErrors(tempErrors);
    return formIsValid;
  };
  // handleSubmit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validation()) {
      // API parameters
      const params = {
        messageSendingSource: parseInt(emailFormData.emailApproach),
        fromEmailAddress: emailFormData.commonEmail,
        smtpServerHost: emailFormData.emailServer,
        smtpLogin: emailFormData.commonEmail,
        smtpPassword: emailFormData.password,
        displayName: emailFormData.displayName,
        dnsText: emailFormData.dnsText,
        createdBy: login.appUserId,
        createdOn: new Date().toJSON().slice(0, 10),
      };

      // Save Method API CALL
      dispatch(saveEmailSetup(config.baseUrl, params));
    }
  };

  useEffect(() => {
    if (config.baseUrl) {
      dispatch(getEmailApproachDropdownList(config.baseUrl));
      dispatch(getEmailPageDetails(config.baseUrl));
    }
  }, [config]);

  return (
    <>
      {loadingFlag > 0 && <Spinner />}
      <Header />
      <Sidebar />

      <div className="page main-margin">
        <div className="page-main">
          <div className="main-content app-content mt-0 main-background">
            <div className="side-app">
              <div className="main-container container-fluid">
                <div className="page-header">
                  <h1 className="page-title">Email Setup</h1>
                </div>
                {errorMessage && <Error errorMessage={errorMessage} />}
                {successMessage && <Success successMessage={successMessage} />}
                <div className="row">
                  <div class="col-xl-12">
                    <form onSubmit={handleSubmit}>
                      <div class="card">
                        <div class="card-body">
                          {/* Forms */}
                          <div className="row">
                            {/* email approach */}
                            <div className="col-lg-6 mt-3">
                              <label className="fw-bold">
                                Email approach{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                className="form-control"
                                name="emailApproach"
                                onChange={handleChange}
                                value={emailFormData.emailApproach}
                              >
                                <option disabled hidden value={""}>
                                  -- Select --
                                </option>
                                {emailApproachList.map((item) => (
                                  <option value={item.id}>{item.name}</option>
                                ))}
                              </select>
                              {
                                <span className="text-danger">
                                  {errors.emailApproach}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div class="card">
                        <div class="card-body">
                          <div className="row"> */}
                      {/* email server */}
                      {emailFormData.emailApproach === "3" ? (
                        <>
                          <div class="card">
                            <div class="card-body">
                              <div className="row">
                                <div className="col-lg-6 mt-3">
                                  <label className="fw-bold">
                                    Email Server / Host{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="emailServer"
                                    onChange={handleChange}
                                    value={emailFormData.emailServer}
                                  />
                                  {
                                    <span className="text-danger">
                                      {errors.emailServer}
                                    </span>
                                  }
                                </div>
                                {/* Display name */}
                                <div className="col-lg-6 mt-3">
                                  <label className="fw-bold">
                                    Display Name{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="displayName"
                                    onChange={handleChange}
                                    value={emailFormData.displayName}
                                  />
                                  {
                                    <span className="text-danger">
                                      {errors.displayName}
                                    </span>
                                  }
                                </div>
                                {/* common email */}
                                <div className="col-lg-6 mt-3">
                                  <label className="fw-bold">
                                    Common Email{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="commonEmail"
                                    onChange={handleChange}
                                    value={emailFormData.commonEmail}
                                  />
                                  {
                                    <span className="text-danger">
                                      {errors.commonEmail}
                                    </span>
                                  }
                                </div>
                                {/* password */}
                                <div className="col-lg-6 mt-3">
                                  <label className="fw-bold">
                                    Password{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="password"
                                    onChange={handleChange}
                                    value={emailFormData.password}
                                  />
                                  {
                                    <span className="text-danger">
                                      {errors.password}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : emailFormData.emailApproach === "2" ? (
                        // DNS TEXT
                        <div class="card">
                          <div class="card-body">
                            <div className="row">
                              <div className="col-lg-6 mt-3">
                                <label className="fw-bold">
                                  DNS Text{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="dnsText"
                                  onChange={handleChange}
                                  value={emailFormData.dnsText}
                                />
                                {
                                  <span className="text-danger">
                                    {errors.dnsText}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="row mt-3">
                        {/* Submit */}
                        <div className="text-end">
                          <button type="submit" className="btn btn-primary">
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
